import { useQueryClient as s, useMutation as o } from "@tanstack/vue-query";
import { pricingRuleKeys as y } from "../ad-group/pricing-rule-keys.js";
import { adGroupKeys as d } from "../ad-group/queries.js";
import { campaignKeys as c } from "../campaign/queries.js";
import "../creative-group/queries.js";
import { targetGroupKeys as u } from "./queries.js";
const K = (i, n) => {
  const t = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const r = {
        campaignId: e.campaignId,
        ...e.body
      };
      return i.targetGroup.create(r);
    },
    onSuccess: async (...e) => {
      const [, r] = e;
      await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, Q = (i, n) => {
  const t = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const r = {
        campaignId: e.campaignId,
        ...e.body
      };
      return i.targetGroup.copy(r);
    },
    onSuccess: async (...e) => {
      const [, r] = e;
      await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, v = (i, n) => {
  const t = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      const r = {
        targetGroupId: e.targetGroupId,
        ...e.body
      };
      return i.targetGroup.update(r);
    },
    onSuccess: async (...e) => {
      const [, r] = e;
      await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), await t.invalidateQueries({ queryKey: d.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: y.bidRanges() }), a && a(...e);
    }
  });
}, w = (i, n) => {
  const t = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => {
      await i.targetGroup.rename({
        targetGroupId: e.targetGroupId,
        ...e.body
      });
    },
    onSuccess: async (...e) => {
      const [, r] = e;
      await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, C = (i, n) => {
  const t = s(), a = n?.onSuccess;
  return o({
    ...n,
    mutationFn: async (e) => i.targetGroup.remove({ targetGroupId: e.targetGroupId }),
    onSuccess: async (...e) => {
      const [, r] = e;
      t.removeQueries({
        queryKey: u.detail(r.campaignId, r.targetGroupId)
      }), await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), a && a(...e);
    }
  });
}, S = (i, n) => {
  const t = s();
  return o({
    ...n,
    mutationFn: async (a) => {
      const e = {
        targetGroupId: a.targetGroupId,
        ...a.body
      };
      return i.targetGroup.update(e);
    },
    onMutate: async (a) => {
      await t.cancelQueries({
        queryKey: u.detail(a.campaignId, a.targetGroupId)
      });
      const e = t.getQueryData(
        u.detail(a.campaignId, a.targetGroupId)
      );
      if (e) {
        const { dimensions: r, ...p } = a.body;
        t.setQueryData(u.detail(a.campaignId, a.targetGroupId), {
          ...e,
          ...p
        });
      }
      return e !== void 0 ? { previousData: e } : {};
    },
    onError: (a, e, r) => {
      r?.previousData && t.setQueryData(
        u.detail(e.campaignId, e.targetGroupId),
        r.previousData
      );
    },
    onSettled: async (a, e, r) => {
      await t.invalidateQueries({ queryKey: u.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: c.all }), await t.invalidateQueries({ queryKey: d.byCampaign(r.campaignId) }), await t.invalidateQueries({ queryKey: y.bidRanges() });
    }
  });
};
export {
  Q as useCopyTargetGroup,
  K as useCreateTargetGroup,
  C as useDeleteTargetGroup,
  w as useRenameTargetGroup,
  v as useUpdateTargetGroup,
  S as useUpdateTargetGroupOptimistic
};
//# sourceMappingURL=mutations.js.map
